import { EntityReputationSource, mockIndicatorQueryQuery } from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockIndicatorQueryQuery(async ({ query: _query, variables: _variables }) => {
    await delay(1500);
    return HttpResponse.json({
      data: {
        __typename: 'Query',
        entity: {
          __typename: 'EntityInterface',
          id: '1',
          reputation: 'Malicious',
          reputationSources: [EntityReputationSource.ThreatIntelligence],
        },
      },
    });
  }),
];
